import { WebsiteApiHelper } from '@/helpers/global/baseAPI.helper';

export interface PartNumberSearchResult {
  part_number: string;
  url: string;
}

interface PartNumberSearchPage {
  url: string;
  part_numbers: string[];
}

let partNumberSearchIndex: PartNumberSearchResult[] | null = null;
let partNumberSearchIndexRequest: Promise<PartNumberSearchResult[]> | null = null;

export const loadPartNumberSearchIndex = (): Promise<PartNumberSearchResult[]> => {
  if (partNumberSearchIndex !== null) {
    return Promise.resolve(partNumberSearchIndex);
  }

  if (partNumberSearchIndexRequest === null) {
    partNumberSearchIndexRequest = WebsiteApiHelper.get('/part_numbers/')
      .then((response) => {
        const pages: PartNumberSearchPage[] = Array.isArray(response.results) ? response.results : [];
        partNumberSearchIndex = pages.flatMap((page) => (
          page.part_numbers.map((partNumber) => ({
            part_number: partNumber.toUpperCase(),
            url: page.url,
          }))
        )).sort((firstResult, secondResult) => (
          firstResult.part_number.localeCompare(secondResult.part_number)
          || firstResult.url.localeCompare(secondResult.url)
        ));
        return partNumberSearchIndex;
      })
      .catch((error) => {
        console.error('Unable to load the part number search index.', error);
        partNumberSearchIndex = [];
        return partNumberSearchIndex;
      });
  }

  return partNumberSearchIndexRequest;
};
